import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {IConfigurationService} from '../../interfaces/IConfigurationService';
import {Config} from '../../models/domain/Config';

@Injectable()
export class ConfigurationService implements IConfigurationService {

  private readonly configLSKey = 'config';
  private config!: Config;

  constructor() {
  }

  getConfig(): Observable<Config> {
    return new Observable<Config>(observer => {
      if (this.config) {
        const c = JSON.parse(JSON.stringify(this.config));
        observer.next(c);
        observer.complete();
      } else {
        const itemsLS = localStorage.getItem(this.configLSKey);
        const configFromLS = itemsLS ? JSON.parse(itemsLS) as Config : undefined;
        this.config = configFromLS || new Config();
        const c = JSON.parse(JSON.stringify(this.config));
        observer.next(c);
        observer.complete();
      }
    });
  }

  saveConfig(config: Config): Observable<void> {
    return new Observable<void>(observer => {
      this.config = config;
      localStorage.setItem(this.configLSKey, JSON.stringify(this.config));
      observer.next();
      observer.complete();
    });
  }
}
